module.exports = __webpack_public_path__ + "img/list2.206536a8.png";